import { render, staticRenderFns } from "./SuccessionLogo.vue?vue&type=template&id=13121b0e&"
import script from "./SuccessionLogo.vue?vue&type=script&lang=ts&"
export * from "./SuccessionLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports